import { LISCaseList } from "pwapi";

const getIncompleteTask = (
  pathCase: LISCaseList | null | undefined,
  type: string
) => {
  if (!pathCase) return undefined;

  for (let i = 0; i < pathCase.work_processes.length; i++) {
    for (let j = 0; j < pathCase.work_processes[i].tasks.length; j++) {
      const task = pathCase.work_processes[i].tasks[j];
      if (task.type === type && !task.completed_at) {
        return task;
      }
    }
  }

  return undefined;
};

export default getIncompleteTask;
